import axios from '@/axios'

export const getLocation = (data) => axios.post('/filingSearch/scope', data)

export const getCaseNoFiling = (data) => axios.post('/filingSearch/caseNoFiling', data)

export const getFilingDetail = (data) => axios.post('/filingSearch/filingDetail', data)

export const getIdCardFiling = (data) => axios.post('/filingSearch/idCardFiling', data)
// 补偿材料提交
export const setModifyRecord = (data) => axios.post('/filingSearch/modifyRecord', data)
// 案件列表查询
export const queryMeetingList = (data) => axios.post('/allInOne/allInOneMeetingList', data)
// 案件详情
export const getCaseDetails = (data) => axios.post('/allInOne/getCaseDetails', data)



// WEBPACK FOOTER //
// ./src/api/caseProgress.js